import axios from "axios";

const prefix =
  process.env.NODE_ENV == "production"
    ? "http://139.129.9.167:5167"
    : "http://139.129.9.167:5167";

export default {
  data() {
    return {
      picbaseurl: prefix + "/common/upload",
    };
  },
  methods: {
    httpPost(url, body = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(prefix + url, body)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error.message);
          });
      });
    },
    httpGet(url, query = {}) {
      return axios
        .get(prefix + url, { params: query })
        .then((resp) => resp.data);
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      console.log(12312);
      let fileName = file.name;
      let f = new FormData();
      f.append("file", file);
      f.append("name", fileName);
      console.log(f);
      axios
        .post(prefix + "/common/upload", f, {
          headers: {
            "content-type": "multipart/form-data",
          },
        })
        .then(function(resp) {
          Editor.insertEmbed(cursorLocation, "image", resp.data.data);
          resetUploader();
        });
    },
  },
};
